var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"90%","margin":"auto"}},[(_vm.time)?_c('h1',[_vm._v(" Where have the trains been recently? ")]):_vm._e(),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c19101e8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marey.vue
// module id = 406
// module chunks = 0